import React, { createContext, useContext } from "react";
import { useMe } from "@/hooks/users/useMe";
import { useUpdateUser } from "@/hooks/users/useUpdateUser";

const AI_CHAT_COLLAPSED_SETTING = "aiChatCollapsed";
const AiChatPanelContext = createContext(null);

export function AiChatPanelProvider({ children }) {
  const { data: meQuery } = useMe();
  const { mutateAsync: updateUser, isPending: isUpdatingUser } =
    useUpdateUser("me");
  const isInvonoAdmin = meQuery?.data?.invonoAdmin === true;
  const isAiChatCollapsed =
    meQuery?.data?.siteSettings?.[AI_CHAT_COLLAPSED_SETTING] ?? false;

  const setAiChatCollapsed = async (collapsed) => {
    if (isUpdatingUser) {
      return;
    }

    await updateUser({
      siteSettings: { [AI_CHAT_COLLAPSED_SETTING]: collapsed },
    });
  };

  return (
    <AiChatPanelContext.Provider
      value={{
        isAiChatCollapsed,
        isInvonoAdmin,
        isUpdatingUser,
        setAiChatCollapsed,
      }}
    >
      {children}
    </AiChatPanelContext.Provider>
  );
}

export function useAiChatPanel() {
  const context = useContext(AiChatPanelContext);

  if (!context) {
    throw new Error("useAiChatPanel must be used within AiChatPanelProvider");
  }

  return context;
}
